// import AvailablesSchedulesCard from "./AvailablesSchedulesCard";
import AvailablesSchedulesCardProfLoader from "./AvailablesSchedulesCardProfLoader";
import AvailablesSchedulesCardSkeleton from "./AvailablesSchedulesCardSkeleton";

export { AvailablesSchedulesCardSkeleton };

export default AvailablesSchedulesCardProfLoader;
// export default AvailablesSchedulesCard;
